"use strict";

(function ($) {

    /* ---------------------------------------------------------------------
     * Header
     * ------------------------------------------------------------------ */

    // The header's height changes as the contact strip wraps, so it is measured
    // rather than assumed. `--header-height` is both the scroll distance that
    // triggers the sticky state and the padding that reserves the header's space
    // while it is pinned.
    var headerHeight = 0;
    var headerStuck = false;
    var headerCtaHeight = 0;

    // Scroll distance after which the direction-driven states kick in, and the
    // slack that stops sub-pixel and trackpad jitter flipping them every frame.
    var DIRECTION_REVEAL_AT = 350;
    var DIRECTION_SLACK = 5;

    var lastScrollTop = 0;
    var scrollingDown = false;

    function isMobileViewport() {
        return window.matchMedia('(max-width: 767px)').matches;
    }

    // Shared by the retracting contact strip and the pinned CTA: hold the last
    // direction until the reader clearly changes their mind.
    function updateScrollDirection(top) {
        var delta = top - lastScrollTop;
        if (Math.abs(delta) <= DIRECTION_SLACK) return;

        scrollingDown = delta > 0;
        lastScrollTop = top;
    }

    // Measure the header and its contact strip at their natural size. A resize
    // can land here mid-retraction, so the collapse is lifted for the read and
    // put back afterwards - otherwise the shrunken header becomes the reserved
    // height and never grows back. `--header-cta-height` lets CSS animate the
    // strip shut and take the same amount off the body padding.
    function setHeaderHeight() {
        var header = document.querySelector('header.header');
        if (!header) return;

        var $header = $(header);
        var strip = header.querySelector('.header-number');
        var wasCollapsed = $header.hasClass('header-scroll');

        if (wasCollapsed) $header.removeClass('header-scroll');

        if (strip) {
            // Read the strip's own layout height, not the value CSS is holding
            // it at through the custom property.
            strip.style.setProperty('height', 'auto');
            headerCtaHeight = $(strip).outerHeight();
            strip.style.removeProperty('height');

            document.body.style.setProperty('--header-cta-height', headerCtaHeight + 'px');
        }

        headerHeight = header.offsetHeight;
        document.body.style.setProperty('--header-height', headerHeight + 'px');

        if (wasCollapsed) $header.addClass('header-scroll');
    }

    // Retract the contact strip while the reader is heading down the page, so
    // the pinned header is just the logo row, and bring it back on the way up.
    // Mobile only - above 768px the strip sits inline in the header bar.
    // Past 350px every scroll step decides it: down adds `.header-scroll`, up
    // removes it. Above that point the last state is held.
    function toggleHeaderScroll() {
        var $header = $('header.header');
        if (!$header.length) return;

        var st = $(window).scrollTop();

        if (!isMobileViewport()) {
            $header.removeClass('header-scroll');
            return;
        }

        // Uses the shared, slack-filtered direction so sub-pixel and trackpad
        // jitter can't flip the strip back and forth.
        if (st > DIRECTION_REVEAL_AT) {
            $header.toggleClass('header-scroll', scrollingDown);
        }

    }

    // Pin the header once it has fully scrolled out of view. `.header-active`
    // takes it out of the flow; `body.header-is-stuck` puts the height it gave
    // up back as padding, so the page never shifts under the reader.
    function toggleStickyHeader() {
        if (!headerHeight) return;

        var shouldStick = $(window).scrollTop() > headerHeight;
        if (shouldStick === headerStuck) return;

        headerStuck = shouldStick;
        $('header.header').toggleClass('header-active', shouldStick);
        // $('body').toggleClass('header-is-stuck', shouldStick);
    }

    // Off-canvas navigation toggle (below 1170px).
    $('.header-menu-toggle').on('click', function () {
        var expanded = $(this).hasClass('active');

        $(this).toggleClass('active').attr('aria-expanded', !expanded);
        $('nav.nav-tablet').toggleClass('nav-open');
        $('body').toggleClass('nav-is-open');
    });

    // Accordion sub-menus in the off-canvas panel. Above 1170px the menu opens
    // on hover, so the tap-to-open behaviour is scoped to narrow viewports.
    // A parent that is a real link keeps working as a link; its sub-menu opens
    // from a separate caret button beside it. Plain-text parents (`.no-link`)
    // have nowhere to go, so the whole label toggles.
    $('nav ul.menu li.menu-item-has-children > a').each(function () {
        var $toggle = $('<button type="button" class="submenu-toggle" aria-expanded="false"><span class="screen-reader-text"></span></button>');
        $toggle.find('.screen-reader-text').text('Show ' + $(this).text().trim() + ' sub-menu');

        $(this).after($toggle).parent().addClass('has-submenu-toggle');
    });

    $('nav ul.menu').on('click', 'li.menu-item-has-children > .submenu-toggle, li.menu-item-has-children > .no-link', function (e) {
        if (window.matchMedia('(min-width: 1170px)').matches) return;

        var $parent = $(this).parent();
        var $submenu = $parent.children('ul.sub-menu');
        if (!$submenu.length) return;

        e.preventDefault();
        $parent.toggleClass('active');
        $parent.children('.submenu-toggle').attr('aria-expanded', $parent.hasClass('active'));
        $submenu.slideToggle(200);
    });

    /* ---------------------------------------------------------------------
     * Sticky mobile CTA
     * ------------------------------------------------------------------ */

    // Below 768px the CTA under the page title pins to the bottom of the
    // viewport once the reader is past the banner, then tucks away while they
    // scroll down and returns on the way back up. `.page-cta-mobile` keeps the
    // button's height so pinning it never shifts the page.
    var ctaHeight = 0;
    var ctaStuck = false;
    var ctaHidden = false;

    // Measure unpinned: while the button is fixed the wrapper has no natural
    // height of its own to read.
    function measureCta() {
        var $wrap = $('.page-cta-mobile');
        if (!$wrap.length || !isMobileViewport()) {
            ctaHeight = 0;
            return;
        }

        var wasStuck = $wrap.hasClass('is-stuck');

        $wrap.removeClass('is-stuck').css('height', '');
        ctaHeight = $wrap.outerHeight();

        if (wasStuck) {
            $wrap.addClass('is-stuck').css('height', ctaHeight + 'px');
        }
    }

    function releaseCta($wrap) {
        ctaStuck = false;
        ctaHidden = false;
        $wrap.removeClass('is-stuck is-hidden').css('height', '');
    }

    function toggleMobileCta() {
        var $wrap = $('.page-cta-mobile');
        if (!$wrap.length) return;

        var top = $(window).scrollTop();

        // Above 768px the button is display:none and sits in the flow anyway.
        if (!isMobileViewport()) {
            if (ctaStuck) releaseCta($wrap);
            return;
        }

        // A resize into mobile can land here before anything has been measured.
        if (!ctaHeight) measureCta();

        var shouldStick = top > DIRECTION_REVEAL_AT;

        if (shouldStick !== ctaStuck) {
            ctaStuck = shouldStick;
            $wrap
                .toggleClass('is-stuck', shouldStick)
                .css('height', shouldStick ? ctaHeight + 'px' : '');
        }

        var shouldHide = ctaStuck && scrollingDown;

        if (shouldHide !== ctaHidden) {
            ctaHidden = shouldHide;
            $wrap.toggleClass('is-hidden', shouldHide);
        }
    }

    // Close the panel on Escape so keyboard users are never trapped in it.
    $(document).on('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!$('nav.nav-tablet').hasClass('nav-open')) return;

        $('.header-menu-toggle').removeClass('active').attr('aria-expanded', false).trigger('focus');
        $('nav.nav-tablet').removeClass('nav-open');
        $('body').removeClass('nav-is-open');
    });

    /* ---------------------------------------------------------------------
     * Sliders
     * ------------------------------------------------------------------ */

    function initSliders() {
        if (typeof $.fn.slick !== 'function') return;

        $('.preload-slider').on('init', function () {
            $('.preload-section').addClass('load-after');
        });

        // Case results — three across on desktop, one with dots below 1170px.
        var $caseResults = $('#sec-two-left-inner');
        if ($caseResults.children('.sec-two-block').length > 1) {
            $caseResults.not('.slick-initialized').slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                adaptiveHeight: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [
                    { breakpoint: 99999, settings: { slidesToShow: 3, dots: false } },
                    { breakpoint: 1170, settings: { slidesToShow: 1, dots: true } }
                ]
            });
        }

        // Testimonials — always one at a time, cross-fading.
        $('#sec-two-slider').not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '.sec-two-mobile-arrow-left',
            nextArrow: '.sec-two-mobile-arrow-right',
            adaptiveHeight: false,
            dots: false,
            fade: true,
            speed: 800,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        prevArrow: '.sec-two-tablet-arrow-left',
                        nextArrow: '.sec-two-tablet-arrow-right'
                    }
                }
            ]
        });

        $('.template-image-slider__track').not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        })

        // Latest news — 1 / 2 / 3 across.
        $('#section-seven .sec-seven-posts-slider').not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 6000,
            prevArrow: '.sec-seven-mobile-arrow-left',
            nextArrow: '.sec-seven-mobile-arrow-right',
            dots: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                        adaptiveHeight: false,
                        prevArrow: '.sec-seven-tablet-arrow-left',
                        nextArrow: '.sec-seven-tablet-arrow-right'
                    }
                },
                {
                    breakpoint: 1170,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                        adaptiveHeight: false,
                        prevArrow: '.sec-seven-tablet-arrow-left',
                        nextArrow: '.sec-seven-tablet-arrow-right'
                    }
                }
            ]
        });

        // The attorney bio has a narrow awards area, so show one logo at a time.
        $('.bio-awards-slider').not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000
        });

        // Generic award / image sliders used across the internal templates.
        // Below 768px the design stacks the award badges rather than putting
        // them in an arrow-less, swipe-only carousel.
        $('.awards-slider').not('.bio-awards-slider, .slick-initialized').slick({
            mobileFirst: true,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                { breakpoint: 1170, settings: { slidesToShow: 4 } },
                { breakpoint: 768, settings: 'unslick' }
            ]
        });

        $('.template-image-slider__track').not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });


    }

    /* ---------------------------------------------------------------------
     * FAQ category filters
     * ------------------------------------------------------------------ */

    $('#filters a').on('click', function (event) {
        event.preventDefault();

        const term = String($(this).data('filter'));
        const $items = $('#items .faq-page-item');

        $(this)
            .addClass('faq-filter-active')
            .siblings()
            .removeClass('faq-filter-active');

        $items.each(function () {
            const terms = String($(this).data('filter-item')).split(' ');
            this.hidden = term !== 'all' && !terms.includes(term);
        });
    });

    /* ---------------------------------------------------------------------
     * Accordions (FAQs)
     * ------------------------------------------------------------------ */

    $(document).on('click', '[data-toggle-accordion]', function (e) {
        e.preventDefault();

        var $trigger = $(this);
        var $panel = $('#' + $trigger.attr('aria-controls'));
        var isOpen = $trigger.hasClass('open');
        var $accordion = $trigger.closest('.accordion-wrapper');

        // Only one panel in this accordion group can remain open at a time.
        $accordion.find('[data-toggle-accordion].open').not($trigger).each(function () {
            var $openTrigger = $(this);
            var $openPanel = $('#' + $openTrigger.attr('aria-controls'));

            $openTrigger.removeClass('open').attr('aria-expanded', 'false');
            $openPanel.removeClass('open');
        });

        $trigger.toggleClass('open', !isOpen).attr('aria-expanded', String(!isOpen));
        $panel.toggleClass('open', !isOpen);
    });

    /* ---------------------------------------------------------------------
     * Scroll-triggered reveals
     * ------------------------------------------------------------------ */

    // Adds `.visible` when a section scrolls into view, which drives the
    // image zoom and the rule that draws itself under section headings.
    function initReveals() {
        var targets = document.querySelectorAll('#sec-three-sidebar, #section-four, #sec-six-inner, #video-wrapper');
        if (!targets.length) return;

        if (!('IntersectionObserver' in window)) {
            targets.forEach(function (el) { el.classList.add('visible'); });
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            });
        }, { rootMargin: '0px 0px -15% 0px' });

        targets.forEach(function (el) { observer.observe(el); });
    }

    /* ---------------------------------------------------------------------
     * Back to top
     * ------------------------------------------------------------------ */

    function toggleBackToTop() {
        $('#scrollToTop').toggleClass('is-visible', $(window).scrollTop() > 500);
    }

    $('#scrollToTop').on('click', function (e) {
        e.preventDefault();
        $('body, html').animate({ scrollTop: 0 }, 500);
    });

    /* ---------------------------------------------------------------------
     * Smooth in-page anchors, offset by the fixed header
     * ------------------------------------------------------------------ */

    $(document).on('click', 'a[href^="#"]:not([href="#"]):not([data-toggle-accordion])', function (e) {
        var target = $($(this).attr('href'));
        if (!target.length || !target.offset()) return;

        e.preventDefault();
        $('html, body').animate({
            scrollTop: target.offset().top - ($('header.header').outerHeight() || 0)
        }, 600);
    });

    /* ---------------------------------------------------------------------
     * HD Modal
     * ------------------------------------------------------------------ */

    $(document).on('click', '.open-hd-modal', function () {
        var title = $(this).data('hd-modal-title');
        var type = $(this).data('hd-modal-content-type');
        var content = $(this).data('hd-modal-content');
        var html = '<div class="hd-modal"><div class="hd-modal-top">';

        if (title) {
            html += '<span class="hd-modal-title">' + title + '</span>';
        }

        html += '<button type="button" class="hd-modal-close" aria-label="Close">' +
            '<svg clip-rule="evenodd" width="24" height="24" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"/></svg>' +
            '</button></div>';

        if (type === 'youtube') {
            html += '<div class="hd-modal-before"><iframe src="https://www.youtube.com/embed/' + content + '?autoplay=1&mute=1" allow="autoplay" allowfullscreen title="Video"></iframe></div>';
        } else if (type === 'wistia') {
            html += '<div class="hd-modal-before"><iframe src="https://fast.wistia.net/embed/iframe/' + content + '" allowfullscreen frameborder="0" scrolling="no" class="wistia_embed" allow="autoplay; fullscreen" title="Video"></iframe></div>';
        } else {
            html += content;
        }

        $('#hd-modal-container').append(html).fadeIn();
    });

    $(document).on('click', '.hd-modal-close, #hd-modal-container', function (e) {
        var clickedBackdrop = $(this).is('#hd-modal-container') && !$(e.target).closest('.hd-modal').length;

        if (clickedBackdrop || $(this).hasClass('hd-modal-close')) {
            $('#hd-modal-container').fadeOut(function () {
                $(this).empty();
            });
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $('#hd-modal-container').children().length) {
            $('#hd-modal-container').fadeOut(function () {
                $(this).empty();
            });
        }
    });

    /* ---------------------------------------------------------------------
     * Blog table of contents
     * ------------------------------------------------------------------ */

    // Each table of contents owns its own toggle: the disclosure button, the
    // list it controls and its label are all looked up inside that instance, so
    // two of them on one page never drive each other. `.is-bound` keeps a second
    // boot pass from stacking a duplicate handler.

    function initTableOfContents() {
        $('.blogSidebar').each(function () {
            var $toc = $(this);

            if ($toc.hasClass('is-bound')) return;
            $toc.addClass('is-bound');

            var $toggle = $toc.find('.contents').first();
            var $wrap = $toc.find('.contents-wrap').first();

            if (!$toggle.length || !$wrap.length) return;

            $toggle.on('click', function () {
                var isOpen = $toggle.attr('aria-expanded') === 'true';

                $toggle.attr('aria-expanded', isOpen ? 'false' : 'true').toggleClass('active', !isOpen);
                $toggle.find('.js-fix').text(isOpen ? 'Expand' : 'Close');
                $wrap.stop(true, true).slideToggle(400);
            });
        });
    }

    /* ---------------------------------------------------------------------
     * Boot
     * ------------------------------------------------------------------ */

    $(function () {
        setHeaderHeight();
        toggleStickyHeader();
        toggleHeaderScroll();
        measureCta();
        toggleMobileCta();
        initSliders();
        initReveals();
        initTableOfContents();
        toggleBackToTop();

        // Signals the hero images to fade in.
        $('body').addClass('ready');
    });

    $(window).on('load', function () {
        setHeaderHeight();
        toggleStickyHeader();
        toggleHeaderScroll();
        measureCta();
        toggleMobileCta();
    });

    $(window).on('scroll', function () {
        // Direction is read once and shared by the states that depend on it.
        updateScrollDirection($(window).scrollTop());

        toggleStickyHeader();
        toggleHeaderScroll();
        toggleMobileCta();
        toggleBackToTop();
    });

    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            setHeaderHeight();
            toggleStickyHeader();
            toggleHeaderScroll();
            measureCta();
            toggleMobileCta();
        }, 150);
    });

})(jQuery);
